import { PostProperties } from "../types";
import image from "../img/lostGemLukeSlater.jpg";

const post: PostProperties = {
  id: 22,
  title: "Luke Slater - Tech Treading, Ambasada Gavioli (29.04.2006)",
  content:
    "The legend himself - Luke Slater. One of the absolute pioneers of the genre that needs no further introduction. Enjoy this rare set recorded back in 2006.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/luke-slater-tech-treading-ambasada-gavioli-29042006",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Легендата лично – Luke Slater. Един от абсолютните пионери на жанра, който не се нуждае от представяне. Насладете се на този рядък сет, записан още през 2006 г.",
  },
};

export default post;
